<template>
  <section>
    <div
      :style="`background-image: url('${require('@/assets/images/login-bg.png')}');`"
      class="bg-img1"
    ></div>

    <div class="login-form-container is-shadow">
      <div class="card">
        <div class="card-image">
          <b-image
            :src="require('@/assets/images/up-skool-logo.png')"
            alt="Placeholder image"
          ></b-image>
        </div>
        <div class="card-content pt-0 pb-6 px-6">
            <h4 class="h4">Your Information</h4>
            <div >
                <b-field label="Name *">
                <b-input type="text"></b-input>
                </b-field>

                <b-field label="Email *">
                <b-input type="email"></b-input>
                </b-field>

                <b-field label="Position *">
                    <b-select placeholder="Select a position" id="position" expanded>
                        <option>Teacher</option>
                    </b-select>
                </b-field>
            </div>
            <hr>
            <h4 class="h4">Your School</h4>
            <div >
                <b-field label="Country *">
                    <b-input type="text">India</b-input>
                </b-field>

                <b-field label="Pincode *">
                    <b-input type="text"></b-input>
                </b-field>

                <b-field label="School *">
                    <b-input type="text"></b-input>
                </b-field>
            </div>
            <hr>
            <h4 class="h4">Your Upskool Trial</h4>
            <div >
                <b-field label="Desired username *">
                    <b-input type="text"></b-input>
                </b-field>

                <b-field label="Subject *">
                    <b-checkbox>Math</b-checkbox>
                    <b-checkbox>Science</b-checkbox>
                </b-field>

                <b-field label="Comment">
                    <b-input id="comment"></b-input>
                </b-field>
            </div>
            <p>
                <b>By accepting this classroom trial, you agree to abide by Upskool's <a target="_blank" href="https://up-skool.com/terms-of-use/">terms of service</a>.</b>
            </p><br>
            <b-button type="is-success" class="is-pulled-right">Request a free trial</b-button>
        </div>
      </div>
    </div>
  </section>
</template>
  
  <script>
export default {
  name: "Membership",
};
</script>
  
  <style>
a{
  color:rgba(0, 0, 0, 0.8);
}
a:hover{
  color:#4e49a1;
}

  .cart-box {
  border: 2px solid #4e49a1;
  color: #fff;
  padding: 1rem 2rem;
}

.text-center {
  text-align: center !important;
}

.h5 {
  font-size: 18px;
  font-weight: 700;
}

.h4 {
  font-size: 24px;
  font-weight: 700;
}

.login-form-container {
  position: absolute;
  width: 100%;
  align-self: center;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-form-container .card-image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 225px;
}

.login-form-container .card-image img {
  width: 200px;
  margin: 0;
}

.login-form-container .card {
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.267);
  width: 60%;
}

/* media query responsive */

@media screen and (max-width: 1024px) {
  .login-form-container .card {
    width: 70%;
  }
}

@media screen and (max-width: 768px) {
  .login-form-container .card {
    width: 80%;
  }

  .login-form-container .card-image {
    height: 150px;
  }

  .login-form-container .card-image img {
    width: 200px;
  }
}
.bg-img1 {
  position: fixed;
  width: 100%;
  min-height: 100vh;
  background-size: 100% 100%;
  background-position: center bottom;
  background-repeat: no-repeat;
  background-color: #999;
}
</style>